import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'progress-step-spinner',
  templateUrl: './progress-step-spinner.component.html',
  styleUrls: ['./progress-step-spinner.component.scss']
})
export class ProgressStepSpinnerComponent implements OnInit, OnChanges {

  mode: ProgressSpinnerMode = 'determinate';
  color: string = 'orange';


  @Input() totalSteps:number;

  @Input() currentStep: number;
  @Input() class: string;
  @Input() ariaLabel: string;

  currentValue: number;


  constructor() { }

  ngOnInit() {

    if(this.totalSteps === null || this.totalSteps === undefined){
      this.totalSteps = 5;
    }
    if(this.currentStep === null || this.currentStep === undefined){
      this.currentStep = 1;
    }

    // Recalculate percentage
    this.updateCurrentValue();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes.currentStep && changes.currentStep.currentValue != changes.currentStep.previousValue){
      // Recalculate percentage
      this.updateCurrentValue();
    }
  }

  private updateCurrentValue(){
    this.currentValue = (this.currentStep / this.totalSteps) * 100;
  }

}
